<template>
  <section>
    <van-row class="banner-panel" v-if="gameInfo['showDown']===2">
      <img :src="entityFileMain+'/'+gameInfo['noDownPage']"/>
    </van-row>
    <van-row v-if="gameInfo['showDown']===1">
      <van-row class="banner-panel" v-if="this.isSetString(gameInfo['landingPage'])">
        <img :src="entityFileMain+'/'+gameInfo['landingPage']"/>
      </van-row>
      <van-row class="icon-panel">
        <van-col class="icon">
          <img :src="entityFileMain+'/'+gameInfo['gameIcon']"/>
        </van-col>
        <van-col class="content">
          <van-row class="name">{{ gameInfo['gameName'] }}</van-row>
          <van-row class="tag">
            <span v-if="this.isSetString(gameInfo['tagOne'])">{{ gameInfo['tagOne'] }}</span>
            <span v-if="this.isSetString(gameInfo['tagTwo'])">{{ gameInfo['tagTwo'] }}</span>
            <span v-if="this.isSetString(gameInfo['tagThree'])">{{ gameInfo['tagThree'] }}</span>
          </van-row>
          <van-row class="info"><span>{{ gameInfo['downloads'] }}</span>人在玩</van-row>
          <van-row class="btns">
            <div class="item" @click="playH5Game();" v-if="this.isSetString(gameInfo['isH5'])">开始游戏</div>
            <div class="item download" @click="downloadGame();" v-if="gameInfo['showDownBtn']===1">下载游戏</div>
          </van-row>
        </van-col>
      </van-row>
      <van-row class="game-about">
        <van-row class="title">游戏简介</van-row>
        <van-row :class="['content',isMore&&'show']">
          <div v-html="gameInfo['describe']"></div>
          <div class="more" v-if="!isMore" @click="handleMore"><span>...</span>更多</div>
        </van-row>
        <van-row class="pic-view">
          <div class="item" v-for="(item,index) in gameInfo['screenshot']" :key="index"
               @click="handlePreview(index)">
            <img :src="entityFileMain+'/'+item"/>
          </div>
        </van-row>
        <p>
          网站备案：{{ webData.webNum }} © {{ webData.WebCompany }}
        </p>
      </van-row>
      <van-row class="footer-panel">
        <van-col class="icon">
          <img :src="entityFileMain+'/'+gameInfo['gameIcon']"/>
        </van-col>
        <van-col class="name">{{ gameInfo['gameName'] }}</van-col>
        <van-col class="btns">
          <div class="download" @click="downloadGame()">下载游戏</div>
        </van-col>
      </van-row>
    </van-row>
  </section>
</template>
<script>

import {ImagePreview} from "vant";
import {WxFeatures} from "../../assets/js/wxFeatures";

export default {
  name: 'MainGameInfo',
  //ref=MainGameView
  props: {},
  data() {
    return {
      isMore: false,
      mRunRomSystem: "android",
      chData: '',
      defaultData: "NTdicjY4NWJy",

      entityFileMain: "",
      gameInfo: {},
      wxData: {},
      webData: {},
    }
  },
  created() {
    this.webData = {"webNum": window.config.WebNum, "WebCompany": window.config.WebCompany};
    this.getLoad();
  },
  mounted() {

  },
  methods: {
    //初始化加载
    getLoad() {
      this.chData = this.$route.query.ch;
      this.mRunRomSystem = this.runRomSystem();
      let params = {
        chData: this.chData ? this.chData : this.defaultData,
        reqSys: "wapWeb",
        runRomSys: this.mRunRomSystem,
        mUrl: encodeURIComponent(self.location.href)
      }
      this.$http(window.config.webHomeApiV2 + '/tg/game_info', params).then((res) => {
        let code = res['code'];
        if (code !== 1) {
          this.BRDialog("提示", res['msg']);
          return;
        }
        let resData = res['data'];
        this.entityFileMain = resData['entityUrl'];
        this.gameInfo = resData['gameData'];
        this.wxData = resData['wxData'];
        let gameName = this.gameInfo['gameName'];
        let gameIcon = this.entityFileMain + "/" + this.gameInfo['gameIcon'];
        let gameDes = this.gameInfo['shortDescribe'];
        let wxShareData = resData['wxData'];
        this.WxFeatures(wxShareData, gameName, gameIcon, gameDes);
      })
    },
    //更多
    handleMore() {
      this.isMore = true;
    },
    //查看图片
    handlePreview(key) {
      let images = this.gameInfo['screenshot'].map(item => {
        return this.entityFileMain + '/' + item;
      })
      ImagePreview({
        images: images,
        startPosition: key
      });
    },

    //下载游戏
    downloadGame() {
      if (this.isRunInWeChatApp()) {
        this.showWXTips();
        return false;
      }
      let params = {
        chData: this.chData ? this.chData : this.defaultData,
        reqSys: "wapWeb",
        runRomSys: this.mRunRomSystem,
      }
      this.$http(window.config.webHomeApiV2 + '/tg/game_download', params).then((res) => {
        let code = res['code'];
        if (code !== 1) {
          this.BRDialog("提示", res['msg']);
          return;
        }
        let resData = res['data'];
        let downLoadType = resData['downLoadType'];
        let gameDownloadUrl = resData['downloadUrl'];
        this.handleDown(resData, downLoadType, gameDownloadUrl);
      });
    },
    //H5在线玩
    playH5Game() {
      if (this.isRunInWeChatApp()) {
        this.showWXTips();
        return false;
      }
      let params = {
        chData: this.chData ? this.chData : this.defaultData,
        reqSys: "wapWeb",
        runRomSys: this.mRunRomSystem,
      }
      this.$http(window.config.webHomeApiV2 + '/tg/game_play_h5', params).then((res) => {
        let code = res['code'];
        if (code !== 1) {
          this.BRDialog("提示", res['msg']);
          return;
        }
        let resData = res['data'];
        window.location.href = resData['playUrl'];
      });
    },

    WxFeatures: function (wxShareData, gameName, gameIcon, gameDes) {
      new WxFeatures({
        wxConfig: wxShareData,
        wxTitle: gameName,
        wxLink: location.href,
        wxImgUrl: gameIcon,
        wxDesc: gameDes,
        wxType: '',
        wxDataUrl: ''
      });
    },
    showWXTips() {
      this.$emit('showWXTips');
    },
    handleDown(resData, downLoadType, gameDownloadUrl) {
      this.$emit('downLoad', resData, downLoadType, gameDownloadUrl);
    },
  }
}
</script>
<style scoped lang='less'>
@import "../../assets/css/home/index.less";
</style>



// WEBPACK FOOTER //
// MainGameInfo.vue?00e8f59a